import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { UNIT_SYSTEMS, UNITS, getDefaultUnits } from '../utils/units';

const UNIT_OPTIONS = [
  { system: UNIT_SYSTEMS.IMPERIAL, unit: 'inches', label: 'in' },
  { system: UNIT_SYSTEMS.IMPERIAL, unit: 'feet', label: 'ft' },
  { system: UNIT_SYSTEMS.METRIC, unit: 'mm', label: 'mm' },
  { system: UNIT_SYSTEMS.METRIC, unit: 'cm', label: 'cm' },
  { system: UNIT_SYSTEMS.METRIC, unit: 'm', label: 'm' },
];

const UnitSelector = ({ onUnitChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSystem, setSelectedSystem] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const defaults = getDefaultUnits();
    setSelectedSystem(defaults.system);
    setSelectedUnit(defaults.unit);
    onUnitChange({ system: defaults.system, unit: defaults.unit });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setSelectedSystem(option.system);
    setSelectedUnit(option.unit);
    onUnitChange({ system: option.system, unit: option.unit });
    setIsOpen(false);
  };

  const currentOption = UNIT_OPTIONS.find(o => o.system === selectedSystem && o.unit === selectedUnit);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center gap-1.5 w-16 py-1.5 text-sm bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-sage-500"
      >
        <span className="font-medium text-gray-700">
          {currentOption ? currentOption.label : '"'}
        </span>
        <ChevronDown className={`w-3 h-3 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50 w-16">
          <div className="p-1">
            {UNIT_OPTIONS.filter(o => o.system === UNIT_SYSTEMS.IMPERIAL).map((option) => (
              <button
                key={option.unit}
                onClick={() => handleSelect(option)}
                className={`w-full text-center px-3 py-1.5 rounded-md text-sm transition-colors ${
                  selectedUnit === option.unit && selectedSystem === option.system
                    ? 'bg-sage-50 text-sage-700 font-medium'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {option.label}
              </button>
            ))}
            <div className="border-t border-gray-200 my-1.5"></div>
            {UNIT_OPTIONS.filter(o => o.system === UNIT_SYSTEMS.METRIC).map((option) => (
              <button
                key={option.unit}
                onClick={() => handleSelect(option)}
                className={`w-full text-center px-3 py-1.5 rounded-md text-sm transition-colors ${
                  selectedUnit === option.unit && selectedSystem === option.system
                    ? 'bg-sage-50 text-sage-700 font-medium'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default UnitSelector;
